import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom"
import { GeaoContext } from "../GeaoContextProvider";
import { GeaoPaths } from "../constants/GeaoPaths";
import { getAnswer } from "../mappers/InterviewMapper";
import Role from "../constants/Role";

export default function useInterviewsInitializedCheck() {
    const navigate = useNavigate();
    const { agencyInterview, agentInterview } = useContext(GeaoContext);

    /**
     * Check that the interviews exist in session storage and navigate back to the Create Your Profile checklist
     * if not.
     */
    useEffect(() => {
        const isPrincipal = getAnswer(agentInterview, "Role") === Role.Principal;

        if (!agentInterview || (isPrincipal && !agencyInterview)) {
            navigate(GeaoPaths.CreateYourProfileChecklist);
        }
    }, [agencyInterview, agentInterview]);
}